import { createSlice } from '@reduxjs/toolkit';
import getAdapter from './getAdapter';

const contactsNotificationsTypesAdapter = getAdapter({ idFieldName: 'value' });

const contactsNotificationsTypesSlice = createSlice({
  name: 'contactsNotificationsTypes',
  initialState: contactsNotificationsTypesAdapter.getInitialState(),
  reducers: {
    setContactsNotificationsTypes: (state, { payload: { contactsNotificationsTypes } }) => {
      contactsNotificationsTypesAdapter.setAll(state, contactsNotificationsTypes);
    }
  }
});

const selectors = contactsNotificationsTypesAdapter.getSelectors(({ contactsNotificationsTypes }) => contactsNotificationsTypes);

export const getContactsNotificationsTypes = state => selectors.selectAll(state);

export const { setContactsNotificationsTypes } = contactsNotificationsTypesSlice.actions;

export default contactsNotificationsTypesSlice.reducer;